const STATE_NAME_TO_ABBR = {
  alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA', colorado: 'CO',
  connecticut: 'CT', delaware: 'DE', florida: 'FL', georgia: 'GA', hawaii: 'HI', idaho: 'ID',
  illinois: 'IL', indiana: 'IN', iowa: 'IA', kansas: 'KS', kentucky: 'KY', louisiana: 'LA',
  maine: 'ME', maryland: 'MD', massachusetts: 'MA', michigan: 'MI', minnesota: 'MN',
  mississippi: 'MS', missouri: 'MO', montana: 'MT', nebraska: 'NE', nevada: 'NV',
  'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY',
  'north carolina': 'NC', 'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK', oregon: 'OR',
  pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC', 'south dakota': 'SD',
  tennessee: 'TN', texas: 'TX', utah: 'UT', vermont: 'VT', virginia: 'VA', washington: 'WA',
  'west virginia': 'WV', wisconsin: 'WI', wyoming: 'WY', 'district of columbia': 'DC',
};

const STATE_ABBRS = new Set(Object.values(STATE_NAME_TO_ABBR));

function normalize(value) {
  return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export function toStateAbbr(value) {
  const normalized = normalize(value).replace(/\./g, '');
  if (!normalized) return '';
  const upper = normalized.toUpperCase();
  if (STATE_ABBRS.has(upper)) return upper;
  return STATE_NAME_TO_ABBR[normalized] || '';
}

export function detectSearchScope(query) {
  const raw = String(query || '').trim();
  if (!raw) return { mode: 'empty', state: '', city: '', query: '' };

  const stateOnly = toStateAbbr(raw);
  if (stateOnly) {
    return { mode: 'state', state: stateOnly, city: '', query: raw };
  }

  const cityStateMatch = raw.match(/^(.+?),\s*([A-Za-z .]{2,})$/);
  if (cityStateMatch) {
    const state = toStateAbbr(cityStateMatch[2]);
    if (state) {
      return {
        mode: 'city',
        city: cityStateMatch[1].trim(),
        state,
        query: raw,
      };
    }
  }

  return { mode: 'address', state: '', city: '', query: raw };
}

export function buildStateSuggestion(input) {
  const state = toStateAbbr(input);
  if (!state) return null;
  const full = Object.entries(STATE_NAME_TO_ABBR).find(([, abbr]) => abbr === state)?.[0] || state;
  const displayName = full.replace(/\b\w/g, (m) => m.toUpperCase());
  return {
    place_id: `state-${state}`,
    description: displayName,
    structured_formatting: {
      main_text: displayName,
      secondary_text: 'State-wide search',
    },
    _types: ['administrative_area_level_1'],
    _scopeMode: 'state',
    _state: state,
  };
}
